import React from 'react';
import * as THREE from 'three';
const Lights = () => {
  return (
    <>
      <pointLight castShadow color="gold" position={[0, 0, 0]} intensity={10} />
      <pointLight
        castShadow
        color="white"
        position={[100, 100, 5]}
        intensity={1}
      />
    </>
  );
};
export default Lights;
